import { DirectusErrorCode } from '@funnellab/shared/src/types/errorCodes';
import { type DirectusError } from '@src/types/errors';

export class NetworkError implements DirectusError {
  extensions: { code: DirectusErrorCode };
  message: string;

  constructor(message: string) {
    this.extensions = { code: DirectusErrorCode.NETWORK_ERROR };
    this.message = message;
  }
}
